import { Box, Flex, useStyleConfig } from '@chakra-ui/react';
import type { FC } from 'react';
import { Else, If, Then } from 'react-if';

import IconButton from '@/components/Button/IconButton';
import { Close } from '@/components/Icon';
import { colors } from '@/styles/theme/constants';

import type { AlertProps } from './types';

export const Alert: FC<AlertProps> = ({ variant, children, dismiss, ...props }) => {
  const styles = useStyleConfig('CustomAlert', { variant });
  const fill = () => {
    switch (variant) {
      case 'default':
        return colors.darkWillow;
      case 'warning':
        return colors.oldTrail;
      case 'info':
        return colors.amnesiaBlue;
      case 'success':
        return colors.jordanJazz;
      case 'error':
        return colors.ottomanRed;
      default:
        return colors.darkWillow;
    }
  };

  return (
    <Box __css={styles} {...props}>
      <If condition={!!dismiss}>
        <Then>
          <Flex align="center" justifyContent="space-between">
            {children}
            <IconButton
              data-testid="alert_buttonClose"
              aria-label="close"
              icon={<Close fill={fill()} />}
              p={0}
              width="24px"
              height="24px"
              minWidth="24px"
              onClick={dismiss}
              ml="16px"
              _hover={{ bg: 'transparent' }}
              _focus={{ bg: 'transparent' }}
              _active={{ bg: 'transparent' }}
            />
          </Flex>
        </Then>
        <Else>{children}</Else>
      </If>
    </Box>
  );
};

export * from './types';
export * from './styleConfig';
